import { NativeInvoiceTermType } from "@common/helpers/invoice-terms.helper";
import { InvoiceSource } from "@common/types/invoice";
import { ClassFilterType } from "@common/types/class";
import { ArAgingBucket } from "@common/types/reports/ar-aging";
import { ViewTableMeta } from "@design-system/ViewTable/ViewTable.lib";
import { AccountingReportFilters } from "../types";

/**
 * Params captured from a clicked Summary amount cell, passed up to the page
 * so it can open the Detail drawer in place instead of navigating away.
 */
export interface ArAgingDetailDrillDownParams {
    asOfDate?: Date | string;
    entityIds?: number[];
    classes?: string[];
    classFilterType?: ClassFilterType;
    /** undefined = every customer; null = unassigned invoices only. */
    customerId?: string | null;
    termTypes?: NativeInvoiceTermType[];
    accountIds?: number[];
    invoiceSources?: InvoiceSource[];
    createdOnFrom?: string;
    createdOnTo?: string;
    dueDateFrom?: string;
    dueDateTo?: string;
    /** Omitted = every bucket (e.g. drilling the customer's Total cell). */
    bucket?: ArAgingBucket;
}

export interface ArAgingSummaryTableCallbacks {
    onDrillDown?: (params: ArAgingDetailDrillDownParams) => void;
}

export type ArAgingSummaryTableMeta = ViewTableMeta<
    ArAgingSummaryTableCallbacks,
    unknown
>;

export function getArAgingSummaryDrillDownParams({
    filters,
    customerId,
    isSummary,
    bucket,
}: {
    filters: AccountingReportFilters;
    customerId: string | null;
    isSummary: boolean;
    bucket?: ArAgingBucket;
}): ArAgingDetailDrillDownParams {
    return {
        asOfDate: filters.asOfDate,
        entityIds: filters.entityIds,
        classes: filters.classes,
        classFilterType: filters.classFilterType,
        customerId: isSummary ? undefined : customerId,
        termTypes: filters.termTypes,
        accountIds: filters.accountIds,
        invoiceSources: filters.invoiceSources,
        createdOnFrom: filters.createdOnFrom,
        createdOnTo: filters.createdOnTo,
        dueDateFrom: filters.dueDateFrom,
        dueDateTo: filters.dueDateTo,
        bucket,
    };
}
